import { Button, Card, Typography } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/features/auth/context/AuthContext';
import { canWriteClientes } from '@/layouts/navigation';
import { CustomersTable } from '../components/CustomersTable';
import { useCustomers } from '../hooks/useCustomers';
import { useAllyFilterOptions } from '../hooks/useAllyFilterOptions';

/**
 * Listado de Clientes (US-2.3, `/clientes`) — paginación server-side vía `useCustomers`.
 *
 * RBAC (espejo del contrato): lectura para `SUPER_ADMIN`, `SOPORTE_N3`, `MARKETING` y
 * `ALIADO_ADMIN`; escritura solo `SUPER_ADMIN`/`SOPORTE_N3`. El filtro por aliado se
 * muestra solo a `SUPER_ADMIN` (el contrato hace efectivo el `aliadoId` solo para él) y
 * `ALIADO_ADMIN` no lista aliados, así que no se piden sus opciones.
 */
export function CustomersListPage() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const customers = useCustomers();
  const canCreate = canWriteClientes(user?.role);
  const canFilterByAlly = user?.role === 'SUPER_ADMIN';
  const canReadAllies = user?.role !== undefined && user.role !== 'ALIADO_ADMIN';
  const allies = useAllyFilterOptions(canReadAllies);

  const goToCreate = () => navigate('/clientes/nuevo');

  return (
    <div className="clientes-page">
      <div className="clientes-page__header">
        <Typography.Title level={3} style={{ margin: 0 }}>
          Clientes
        </Typography.Title>
        {canCreate && (
          <Button type="primary" icon={<PlusOutlined />} onClick={goToCreate}>
            Nuevo cliente
          </Button>
        )}
      </div>

      <Card>
        <CustomersTable
          customers={customers.data}
          meta={customers.meta}
          loading={customers.loading}
          error={customers.error}
          filters={customers.filters}
          canCreate={canCreate}
          canFilterByAlly={canFilterByAlly}
          allies={allies}
          onFiltersChange={customers.setFilters}
          onOffsetChange={customers.setOffset}
          onRetry={customers.refresh}
          onCreate={goToCreate}
          onSelect={(customerId) => navigate(`/clientes/${encodeURIComponent(customerId)}`)}
          onSelectFleet={(fleetId) => navigate(`/flotas/${encodeURIComponent(fleetId)}`)}
        />
      </Card>
    </div>
  );
}
